import {
    Button,
    Flex,
    NumberInput,
    Select,
    SelectItem,
    Text,
    Textarea,
    TextInput,
} from '@tremor/react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useApiV1TicketCreate } from '../../api/api.gen'
import { toErrorText } from '../../utilities/error'
import { ModelVMType } from '../../api/api'

export default function PostgreSQLTicketModal() {
    const [clusterName, setClusterName] = useState<string>('')
    const [volumeSize, setVolumeSize] = useState<number>(0)
    const [nodeType, setNodeType] = useState<ModelVMType>(
        ModelVMType.VMTypeBurstable2Core4GB
    )

    const {
        response: createTicketResponse,
        isLoading: createTicketLoading,
        isExecuted: createTicketExecuted,
        sendNowWithParams: createTicket,
        error: createError,
    } = useApiV1TicketCreate({}, {}, {}, false)

    const navigate = useNavigate()
    useEffect(() => {
        if (createTicketExecuted && !createTicketLoading) {
            navigate(`/ticket/${createTicketResponse}#close_sidebar_modal`)
        }
    }, [createTicketLoading])

    return (
        <Flex
            className="p-4 bg-gray-50 w-auto max-w-fit rounded-md"
            flexDirection="col"
            justifyContent="start"
            alignItems="start"
        >
            <Text className="mt-4 mb-1">DB name:</Text>
            <TextInput
                value={clusterName}
                onValueChange={setClusterName}
                error={clusterName.length === 0}
                errorMessage="Cluster name is required"
            />

            <Text className="mt-4 mb-1">Node type:</Text>
            <Select
                value={nodeType}
                onValueChange={(v) => {
                    setNodeType(v as ModelVMType)
                }}
                error={nodeType.length === 0}
                errorMessage="Type is required"
            >
                <SelectItem value={ModelVMType.VMTypeBurstable2Core4GB}>
                    2cores, 4GB
                </SelectItem>
                <SelectItem value={ModelVMType.VMTypeBurstable4Core16GB}>
                    4cores, 16GB
                </SelectItem>
                <SelectItem value={ModelVMType.VMTypeComputeOptimized8Core16GB}>
                    8cores, 16GB
                </SelectItem>
                <SelectItem value={ModelVMType.VMTypeMemoryOptimized8Core32GB}>
                    8cores, 32GB
                </SelectItem>
                <SelectItem value={ModelVMType.VMTypeMemoryIntensive8Core64GB}>
                    8cores, 64GB
                </SelectItem>
            </Select>
            <Text className="mt-4 mb-1">Volume Size (GB):</Text>
            <NumberInput
                min={8}
                max={4096}
                value={volumeSize}
                onValueChange={setVolumeSize}
                error={volumeSize < 8 || volumeSize > 4096}
                errorMessage="Volume size must be within 8-4096 range"
            />

            <div className="mt-8">{toErrorText(createError)}</div>
            <Button
                className=""
                color="teal"
                loading={createTicketExecuted && createTicketLoading}
                disabled={createTicketExecuted && createTicketLoading}
                onClick={() => {
                    createTicket(
                        {
                            id: 0,
                            newTicket: true,
                            title: 'Request for Managed PostgreSQL',
                            content: `Managed PostgreSQL with following configuration
DB name: ${clusterName}
Node type: ${nodeType}
Volume size: ${volumeSize}`,
                        },
                        { service: 'PostgreSQL' },
                        {}
                    )
                }}
            >
                Create
            </Button>
        </Flex>
    )
}
